import {useMutation} from 'react-query';
import {
  IPostLoanValidationPaymentPayload,
  postLoanValidationPayment,
} from './postLoanValidationPayment';

interface UsePostLoanValidationPaymentProps
  extends IPostLoanValidationPaymentPayload {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const usePostLoanValidationPayment = ({
  loan_request,
  onSuccess,
  onError,
}: UsePostLoanValidationPaymentProps) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: () => postLoanValidationPayment({loan_request}),
    onSuccess: data => {
      onSuccess?.(data);
    },
    onError: error => {
      onError?.(error);
    },
  });

  return {mutate, isLoading};
};

export default usePostLoanValidationPayment;
